/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
* {
  box-sizing: border-box;
}

:host {
  position: relative;
  text-align: left;
  color: var(--davinci-color-text-dark, );
  font-size: 1rem;
  margin: 0 1.7142857143rem;
}

:host(.right) {
  flex-grow: 1;
  text-align: right;
}

.menu-button {
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
  cursor: pointer;
}
.menu-button.open {
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}
.menu-button:hover {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}

.menu {
  position: absolute;
  white-space: nowrap;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-03dp, #FFFFFF);
  z-index: 8;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  right: -0.2142857143rem;
  top: 2.8571428571rem;
}
.menu .inner-container {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 1.1428571429rem;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-03dp, #FFFFFF);
}
.menu .inner-container:before {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-03dp, #FFFFFF);
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  content: "";
  height: 0.8571428571rem;
  position: absolute;
  right: 0.7857142857rem;
  top: -0.3571428571rem;
  transform: rotate(45deg);
  width: 0.8571428571rem;
  z-index: -1;
}

.click-catcher {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 6;
}
.click-catcher.active {
  display: block;
}

::slotted(davinci-navigation-menu-item:not(:last-of-type)) {
  margin-bottom: 1.7142857143rem;
}
`;
export { style };
